<template>
  <el-dialog
    :model-value="true"
    :title="$t('pages.app.headlines.ie_not_supported')"
    width="35em"
    center
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <span class="tc-text-class" v-html="$t('pages.app.messages.ie_not_supported')" />
  </el-dialog>
</template>

<script setup lang="ts">
</script>

<style lang="scss" scoped>

  .tc-text-class {
    word-break: normal;
  }
</style>
